<template>
  <div class="animated fadeIn">
    <basic-heading title="Work Groups" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list sample type'">
      <template #gated-content>
        <work-group-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import WorkGroupServerTable from "@/components/lab/workgroup/WorkGroupServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "WorkGroupIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkGroupServerTable,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/workgroups/add",
            title: "Add work group",
            variant: "success",
            permission: this.checkPermission("add work group"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
